/* eslint-disable react/jsx-pascal-case */
import { Button, Col, ConfigProvider, Form, Row, Modal, message } from "antd";
import dayjs from 'dayjs';
import React, { useContext, useEffect, useRef, lazy, Suspense, useState } from "react";
import UserForm from "./UserForm";
import { useUser } from "../controller/UserController";

const { ConfigContext } = ConfigProvider


const UserSelfModal = (
    {
        axiosMode = "patch",
        propsForm,
        propsOpen = null,
        propsLoading = null,
        propsSetOpen = () => {

        },
        // onFinish = () => {

        // }
    }
) => {

    const axiosModelanguage = {
        post: "新增",
        patch: "修改"
    }
    const [form] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false)
    const [formReloadCount, setFormReloadCount] = useState(0)

    const showModal = () => {
        setFormReloadCount(pre => pre + 1)
        if (propsOpen === null) {
            setIsModalOpen(true);
        }
        else {
            propsSetOpen(true)
        }
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        }
        else {
            propsSetOpen(false)
        }
    }

    const handleOk = () => {
        setLoading(true)
        if (propsForm) {
            propsForm.submit()
        }
        else {
            form.submit()
        }
    };

    const handleCancel = () => {
        closeModal()
    };
    const onFormFinish = (values) => {
        patchUserSelfData([values])
    }
    const onBefore = ({ axiosMode, status, values }) => {
        // setModalLoading(true)
    }
    const onFinish = ({ axiosMode, status, values }) => {

        if (status === "success") {
            if (axiosMode === "patch") {
                message.success("修改成功")
                setLoading(false)
                getUserSelfData({})
                closeModal()
            }
        }
        else if (status === "error") {
            if (axiosMode === "patch") {
                message.error("修改失敗")
                setLoading(false)
                getUserSelfData({})
                closeModal()
            }
        }

    }
    const {
        UserSelfData,
        getUserSelfData,
        patchUserSelfData
    } = useUser({
        onFinish,
        onBefore,
    })
    useEffect(() => {
        let firstData = UserSelfData.find((e) => true)
        form.setFieldsValue({ ...firstData })
    }, [UserSelfData])
    useEffect(() => {
        getUserSelfData({})
    }, [])
    useEffect(() => {
        setFormReloadCount(pre => pre + 1)
    }, [propsOpen])
    return (
        <>
            {
                propsOpen === null &&
                <a
                onClick={showModal}>
                    {
                        `${axiosModelanguage[axiosMode]}個人資料`
                    }
                </a>
            }

            <Modal
                title={`${axiosModelanguage[axiosMode]}資料`}
                open={propsOpen === null ? isModalOpen : propsOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                confirmLoading={propsLoading === null ? loading : propsLoading}
                maskClosable={false}
            >
                <Row>
                    <Col span={24}>
                        <UserForm
                            formReloadCount={formReloadCount}
                            open={propsOpen === null ? isModalOpen : propsOpen}
                            axiosMode={axiosMode}
                            propsForm={propsForm ? propsForm : form}
                            onFormFinish={onFormFinish}
                        />
                    </Col>
                </Row>
            </Modal>
        </>

    )
}


export default UserSelfModal;
